import { CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from "chart.js";
import { Line } from "react-chartjs-2";
import { useTheme } from "../../styles/useTheme";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface DataArr {
  graphData?: string[] | number[];
  ymax?: number;
  labels?: string[];
  label?: string;
  unit?: string;
  color?: string;
}

export const LineGraph = ({ graphData = [], labels, label = "", unit = "", ymax }: DataArr) => {
  useTheme(); // Re-read resolved CSS colors when the administrator changes theme.
  const tokens = getComputedStyle(document.documentElement);
  const tickColor = tokens.getPropertyValue('--color-text-secondary').trim();
  const lineColor = tokens.getPropertyValue('--color-text-link').trim();
  const gridColor = tokens.getPropertyValue('--color-border-default').trim();
  return <Line
  aria-label={`${label} 일별 추이`}
  role="img"
  data={{
    labels: labels || graphData.map((_, index) => `${index + 1}일`),
    datasets: [{ label, data: graphData, borderColor: lineColor, backgroundColor: lineColor, borderWidth: 2, pointRadius: graphData.length > 14 ? 2 : 4, tension: 0.2 }],
  }}
  options={{
    responsive: true,
    maintainAspectRatio: false,
    interaction: { intersect: false, mode: "index" },
    scales: {
      x: { grid: { display: false }, ticks: { color: tickColor, maxTicksLimit: 8 } },
      y: { min: 0, suggestedMax: ymax, border: { display: false }, grid: { color: gridColor }, ticks: { color: tickColor, precision: 0 } },
    },
    plugins: { legend: { display: false }, tooltip: { callbacks: { label: context => `${label}: ${Number(context.parsed.y).toLocaleString("ko-KR")}${unit}` } } },
  }}
/>;
};
